import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../lib/cn';
const SHAPE = {
    round: 'rounded-full',
    square: 'rounded-[4px]',
};
const SIZE = {
    md: 'min-h-[40px] px-4 text-[14px] font-medium',
    sm: 'min-h-[36px] px-3 text-[13px] font-medium',
    xs: 'px-2.5 py-1 text-[10.5px] font-semibold uppercase tracking-[0.06em]',
};
/*
 * Every tone carries a border so hovering into one never shifts layout;
 * the light tones keep it transparent. `text-ink` follows the theme on
 * surfaces that flip with it (cream-dark, surface, ink); bleu gris is the
 * same #CED6D5 in both themes, so its text is the pinned navy.
 */
const TONE = {
    amande: {
        base: 'border-transparent bg-cream-dark text-ink',
        hover: 'hover:border-border-deep hover:bg-surface',
    },
    navy: {
        base: 'border-transparent bg-ink text-cream',
        hover: 'hover:bg-ink-soft',
    },
    'bleu-gris': {
        base: 'border-transparent bg-bleu-gris text-ink-on-tint',
        hover: 'hover:bg-bleu-gris-light',
    },
    outline: {
        base: 'border-border bg-surface text-ink',
        hover: 'hover:border-ink-soft',
    },
    dore: {
        base: 'border-transparent bg-terra text-ink-on-tint',
        hover: '',
    },
};
const SELECTED = 'border-transparent bg-vert text-ink-on-tint';
export function Pill({ shape = 'round', tone = 'amande', size = 'md', selected = false, as, interactive, className, children, ...rest }) {
    const element = tone === 'dore' ? 'span' : (as ?? (rest.onClick ? 'button' : 'span'));
    const hover = tone !== 'dore' && (interactive ?? element === 'button');
    const classes = cn('inline-flex items-center justify-center gap-1 whitespace-nowrap border transition-colors', SHAPE[shape], SIZE[size], selected ? SELECTED : TONE[tone].base, hover && !selected && TONE[tone].hover, className);
    if (element === 'button') {
        return (_jsx("button", { type: "button", "aria-pressed": selected || undefined, className: classes, ...rest, children: children }));
    }
    return (_jsx("span", { className: classes, ...rest, children: children }));
}
//# sourceMappingURL=pill.js.map